import { SelectOption } from '@/types';
import { addHours } from 'date-fns';

import { getBrandPlaceData, getChannel, getPlaceId } from '@/lib/server';

import { EventSearch } from '../components/events';
import { SearchContext } from '../util/search-context';
import { BlockBase, getMarginClassNames } from './utils';

export interface EventsBlockProps extends BlockBase {
  /** Category, Venue, City can be enabled here */
  filters: SelectOption[];
  /** set the default category */
  defaultCategory: SelectOption[];
  /** filter by place ID */
  places: { id: string }[];
  /** filter by event ID */
  events: { id: string }[];
  /** Timeline, Calendar, Carousel Large, Carousel Small can be enabled here */
  views: SelectOption[];
}

export async function Events({ filters, defaultCategory, places, events, views, params, margin }: EventsBlockProps) {
  const channel = await getChannel(decodeURIComponent(params.domain));

  if (!channel) {
    return null;
  }

  const { placeId } = params.venue
    ? await getPlaceId(channel, decodeURIComponent(params.venue))
    : channel.places.length === 1
      ? { placeId: channel.places[0].id }
      : {};
  const { places: placesData } = placeId ? { places: [] } : await getBrandPlaceData(decodeURIComponent(params.domain));

  const datesStart = Math.round(addHours(new Date(), -3).getTime() / 1000);

  return (
    <SearchContext
      contentForm="event"
      initialUiState={{
        range: { dates: `${datesStart}:` },
        refinementList: {
          category: [defaultCategory?.[0]?.label],
        },
      }}
      sortBy="dates:asc"
      configure={{
        hitsPerPage: 36,
        filters: [
          `_referencedBy:=[${[...(places || placesData)?.map((p) => p.id), placeId].filter(Boolean).join(',')}]`,
          Boolean(events?.length) &&
            `id:=[${events.map((e) =>
              [
                e.id,
                Array.from({ length: 100 })
                  .map((_, i) => `${e.id}_dates_${i + 1}`)
                  .join(','),
              ]
                .flat()
                .join(','),
            )}]`,
        ]
          .filter(Boolean)
          .join(' && '),
      }}
    >
      <EventSearch placesData={placesData} views={views} filters={filters} className={getMarginClassNames(margin)} />
    </SearchContext>
  );
}
